import React from 'react';
import './App.css';
import {Switch,Route,Link} from 'react-router-dom';
import Register from './pages/RegisterPage';
import TestPage from './pages/TestPage';
import Footer from './components/footer-component/footer.component';




class App extends React.Component{
  render(){
    return(
<div><div className='Container' >
  <video  autoPlay loop muted   className='Content'>
  <source src='https://firebasestorage.googleapis.com/v0/b/biocidiedukacija.appspot.com/o/video%2Fvideo.mp4?alt=media&token=ae821c6d-6c0d-4dfc-a946-97e58575dd25' type='video/mp4'/>

  </video>
<Link to='/' className='SubContent'> <img className='logo'  src='https://firebasestorage.googleapis.com/v0/b/biocidiedukacija.appspot.com/o/slike%2FZavod%20edukacija%203D.png?alt=media&token=417fc536-dafc-45c1-a508-81ced3200434' alt='logo'/></Link>

</div>
<Switch>

<Route exact path='/' component={TestPage}/>
<Route exact path='/registracija' component={Register} />

</Switch>

<Footer/>
</div>


    );
  }
}

export default App;
